// Third-party libraries
import React, { useContext } from "react";
import { Typography, TextField, Stack } from "@mui/material";

// Local modules
import { BandsContext } from "../../../../utils/stateHandlers/contexts";

export default function BandsSpecialInstructions() {
  const { bandsState, bandsDispatch } = useContext(BandsContext);
  const { priceLoaded, specialInstructions } = bandsState;
  return (
    <Stack>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        Special Instructions
      </Typography>
      <TextField
        color="primary"
        variant="outlined"
        size="small"
        sx={{
          width: "100%",
          margin: "unset",
        }}
        onChange={(e) => {
          bandsDispatch({
            type: "setSpecialInstructions",
            payload: e.target.value,
          });
        }}
        value={specialInstructions || ""}
        disabled={!priceLoaded}
        inputProps={{
          style: {
            fontSize: 15,
            paddingBottom: 100,
          },
        }}
      />
    </Stack>
  );
}
